import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Icon from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronRight from "@ucs/Icons/ChevronRight";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const FeaturedProjectsContainer = styled.div`
    background-color: transparent;
    padding: 10%;
    height: 100%;
    ul {
        font-size: 18px;
        li {
            margin-bottom: 25px;
            >span {
                margin-right: 8px;
            }
        }
    }
`;

const FeaturedProjects: React.FC<WidgetProps> = props => {
    return (
        <FeaturedProjectsContainer>
            Featured projects go here
        </FeaturedProjectsContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(FeaturedProjects),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
